export const tradesFLocation = "/foreign/trades";
